import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LocationModal from "../components/LocationModal";
import Logo from "./Logo";
import { IconArrowLeft } from "./Icons";

function Header() {
  const [loadingLocation, setLoadingLocation] = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  const [showModal, setShowModal] = useState(false);
  const [errorMsg,  setErrorMsg]  = useState("");

  const isAddBusinessPage   = location.pathname === "/add-business";
  const isAdminLoginPage    = location.pathname === "/admin/login";
  const isAdminDashboard    = location.pathname === "/admin";
  const isBusinessOwnerPage = location.pathname.startsWith("/business-owner");

  const handleRegisterClick = () => {
    setErrorMsg("");
    setShowModal(true);
  };

  const handleAllow = () => {
    setErrorMsg("");
    if (!navigator.geolocation) {
      setErrorMsg("Geolocation not supported");
      return;
    }
    setLoadingLocation(true);
    navigator.geolocation.getCurrentPosition(
      () => {
        setLoadingLocation(false);
        setShowModal(false);
        navigate("/add-business");
      },
      (err) => {
        setLoadingLocation(false);
        switch (err.code) {
          case 1: setErrorMsg("Location permission denied. Please allow it in browser settings."); break;
          case 2: setErrorMsg("Location is OFF. Please enable GPS / Location services."); break;
          case 3: setErrorMsg("Location request timed out. Please try again."); break;
          default: setErrorMsg("Unable to get location");
        }
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 }
    );
  };

  const handleCancel = () => {
    setShowModal(false);
    setErrorMsg("");
  };

  const handleManual = () => {
    setShowModal(false);
    setErrorMsg("");
    navigate("/add-business", { state: { manualLocation: true } });
  };

  // Check localStorage for an existing business owner session
  const ownerToken        = localStorage.getItem("businessOwnerToken");
  const ownerBusinessName = localStorage.getItem("businessOwnerName");
  const isOwnerLoggedIn   = Boolean(ownerToken);

  const renderOwnerButton = () => {
    if (isOwnerLoggedIn) {
      return (
        <button
          className="wireframe-button owner-dashboard-btn"
          onClick={() => navigate("/business-owner/edit")}
          title={ownerBusinessName ? `Managing: ${ownerBusinessName}` : "My Business"}
        >
          My Business
        </button>
      );
    }
    return (
      <button
        className="wireframe-button owner-login-btn"
        onClick={() => navigate("/business-owner/login")}
      >
        <span className="btn-full">Owner Login</span>
        <span className="btn-abbr">Login</span>
      </button>
    );
  };

  return (
    <>
      <div className="wireframe-header">
        <div className="logo-container">
          <Logo className="logo-icon" />
          <div className="logo-text-group">
            <div className="logo-title">BusinessNearMe</div>
          </div>
        </div>

        <div className="header-actions">
          {isAddBusinessPage ? (
            <button className="wireframe-button" onClick={() => navigate("/")}>
              <span className="icon-row">
                <IconArrowLeft size={14} />
                Back
              </span>
            </button>

          ) : isAdminLoginPage ? (
            <button className="wireframe-button" onClick={() => navigate("/")}>
              <span className="icon-row">
                <IconArrowLeft size={14} />
                Exit Admin
              </span>
            </button>

          ) : isAdminDashboard || isBusinessOwnerPage ? (
            null

          ) : (
            <>
              {renderOwnerButton()}
              <button className="wireframe-button" onClick={handleRegisterClick}>
                <span className="btn-full">Register Business</span>
                <span className="btn-abbr">Register</span>
              </button>
            </>
          )}
        </div>
      </div>

      {showModal && (
        <LocationModal
          onAllow={handleAllow}
          onCancel={handleCancel}
          onManual={handleManual}
          error={errorMsg}
          loading={loadingLocation}
        />
      )}
    </>
  );
}

export default Header;
